import { eyebrowFont } from '@config/mui-theme'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  subtitle: {
    marginBottom: '3.125rem',
    width: '80%',
  },
  image: {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
  },
  spotlightImage: {
    height: 'auto',
    width: '60%',
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
    },
  },
  gridContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-around',
    alignItems: 'center',
    flexDirection: 'row',
    background: theme.palette.primary.contrastText,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      alignItems: 'center',
      height: '100%',
      width: '70%',
      objectFit: 'cover',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      objectFit: 'cover',
    },
  },
  button: {
    fontFamily: eyebrowFont,
    fontWeight: '700',
    letterSpacing: '0.4px',
    borderRadius: '4px',
    height: 'inherit',
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
    '&.MuiButton-contained': {
      boxShadow: theme.shadows[2],
    },

    [theme.breakpoints.only('xs')]: {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
  },
  headline: {
    margin: '1.5rem 0',
    color: theme.palette.secondary.light,
  },
  textWrapper: {
    [theme.breakpoints.down('sm')]: {
      padding: '0 7px',
    },
  },
}))

export default useStyles
